import { Component, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { map } from 'rxjs';
import { documentToHtmlString } from '@contentful/rich-text-html-renderer';
import { Document as ContentfulDocument } from '@contentful/rich-text-types';
import { TimeoutService } from '../services/timeout.service';
import { UserService } from '../services/user.service';
import { SafeHtmlPipe } from '../pipes/safe-html.pipe';

interface SessionPageContent {
  error: string;
  headingText1: string;
  headingText2: string;
  description: { json: ContentfulDocument };
  logOutButtonText: string;
  continueButtonText: string;
  image: { url: string };
}

@Component({
    selector: 'app-session',
    imports: [SafeHtmlPipe],
    templateUrl: './session.component.html',
    styleUrls: ['./session.component.scss']
})
export class SessionComponent {
  private userService = inject(UserService);
  timeoutService = inject(TimeoutService);

  private readonly parsedContent = toSignal<SessionPageContent | null>(
    (this.timeoutService.sessionPageContent$ as import('rxjs').Observable<string>).pipe(map(data => JSON.parse(data) as SessionPageContent)),
    { initialValue: null }
  );

  readonly error = computed(() => this.parsedContent()?.error ?? '');
  readonly headingText1 = computed(() => this.parsedContent()?.headingText1 ?? '');
  readonly headingText2 = computed(() => this.parsedContent()?.headingText2 ?? '');
  readonly description = computed(() =>
    this.parsedContent()?.description?.json
      ? documentToHtmlString((this.parsedContent() as SessionPageContent).description.json)
      : ''
  );
  readonly logOutButtonText = computed(() => this.parsedContent()?.logOutButtonText ?? '');
  readonly continueButtonText = computed(() => this.parsedContent()?.continueButtonText ?? '');
  readonly sessionImageUrl = computed(() => this.parsedContent()?.image?.url ?? '');

  logoutClick(): void {
    ////////// Logout //////////
    this.userService.logoutApp();
  }
}
